(() => {
  const root = document.currentScript?.closest('.sp-product');
  if (!root) return;

  const product = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const form = root.querySelector('.sp-form');
  const variantInput = root.querySelector('[data-variant-id]');
  const priceEl = root.querySelector('[data-price]');
  const compareEl = root.querySelector('[data-compare-price]');
  const addBtn = root.querySelector('[data-add-to-cart]');
  const addLabel = root.querySelector('[data-add-label]');
  const stickyBtn = root.querySelector('[data-sticky-add]');
  const stickyPrice = root.querySelector('[data-sticky-price]');
  const qtyInput = root.querySelector('[data-qty-input]');

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(cents / 100);
    } catch(e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const findVariant = () => {
    const selected = {};
    root.querySelectorAll('[data-option-position]').forEach(btn => {
      if (btn.classList.contains('is-selected')) selected[btn.dataset.optionPosition] = btn.dataset.optionValue;
    });
    return product.variants.find(v => {
      return Object.keys(selected).every(pos => v.options[Number(pos) - 1] === selected[pos]);
    }) || product.variants[0];
  };

  const updateVariant = () => {
    const variant = findVariant();
    if (!variant) return;

    variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (stickyPrice) stickyPrice.textContent = money(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.hidden = false;
        compareEl.textContent = money(variant.compare_at_price);
      } else {
        compareEl.hidden = true;
      }
    }

    const available = variant.available;
    if (addBtn) {
      addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? (addBtn.dataset.addLabelAvailable || 'Add to cart') : (addBtn.dataset.addLabelSold || 'Sold out');
    }
    if (stickyBtn) stickyBtn.disabled = !available;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  root.querySelectorAll('[data-option-position]').forEach(btn => {
    btn.addEventListener('click', () => {
      const position = btn.dataset.optionPosition;
      root.querySelectorAll(`[data-option-position="${position}"]`).forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      updateVariant();
    });
  });

  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
  });
  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + 1);
  });

  // Gallery
  const slides = [...root.querySelectorAll('[data-media-slide]')];
  const thumbs = [...root.querySelectorAll('[data-media-thumb]')];
  let current = 0;
  const showSlide = (index) => {
    if (!slides.length) return;
    current = (index + slides.length) % slides.length;
    slides.forEach((s, i) => { s.hidden = i !== current; s.classList.toggle('is-active', i === current); });
    thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === current); t.setAttribute('aria-current', i === current ? 'true' : 'false'); });
  };
  thumbs.forEach((t, i) => t.addEventListener('click', () => showSlide(i)));
  root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(current - 1));
  root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(current + 1));

  // Fulfillment tabs
  const deliveryPanel = root.querySelector('[data-delivery-panel]');
  const pickupPanel = root.querySelector('[data-pickup-panel]');
  root.querySelectorAll('[data-fulfillment-tab]').forEach(tab => {
    tab.addEventListener('click', () => {
      root.querySelectorAll('[data-fulfillment-tab]').forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');
      const delivery = tab.dataset.fulfillmentTab === 'delivery';
      if (deliveryPanel) deliveryPanel.hidden = !delivery;
      if (pickupPanel) pickupPanel.hidden = delivery;
    });
  });

  // Description tabs
  const switchTab = (name) => {
    root.querySelectorAll('[data-tab]').forEach(tab => {
      const active = tab.dataset.tab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-panel]').forEach(panel => {
      panel.hidden = panel.dataset.panel !== name;
      panel.classList.toggle('is-active', panel.dataset.panel === name);
    });
  };
  root.querySelectorAll('[data-tab]').forEach(tab => tab.addEventListener('click', () => switchTab(tab.dataset.tab)));

  root.querySelector('[data-scroll-description]')?.addEventListener('click', () => {
    root.querySelector('[data-description]')?.scrollIntoView({behavior:'smooth'});
  });
  root.querySelector('[data-scroll-reviews]')?.addEventListener('click', () => {
    root.querySelector('[data-description]')?.scrollIntoView({behavior:'smooth'});
    switchTab('reviews');
  });

  // Native share
  root.querySelector('[data-share]')?.addEventListener('click', async () => {
    const data = {title: document.title, url: window.location.href};
    if (navigator.share) {
      try { await navigator.share(data); } catch(e) {}
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(window.location.href);
      alert('Product link copied.');
    }
  });

  root.querySelector('[data-list]')?.addEventListener('click', () => {
    alert('Connect this button to your wishlist app or Shopify customer account.');
  });
  root.querySelector('[data-compare]')?.addEventListener('click', () => {
    alert('Connect this button to your comparison app or custom compare logic.');
  });

  stickyBtn?.addEventListener('click', () => {
    addBtn?.click();
  });

  // Prevent duplicate form submission while the cart request is processing.
  form?.addEventListener('submit', () => {
    if (!addBtn || addBtn.disabled) return;
    addBtn.setAttribute('aria-busy', 'true');
    window.setTimeout(() => addBtn.removeAttribute('aria-busy'), 1200);
  });

  updateVariant();
})();
